<!-- Form state -->
<ng-container *ngIf="showFeedbackSection">
    <div class="feedback-container" *ngIf="showForm">
        <div class="feedback-header">
            <div class="feedback-icon">
                <ng-icon name="heroQuestionMarkCircle" color="#822AC6" [size]="'18px'"></ng-icon>
            </div>
            <div class="feedback-text">How did you hear about us?</div>
        </div>
        <div class="dropdown-container" ngbDropdown placement="bottom-left">
            <div class="feedback-dropdown" ngbDropdownToggle id="referralSourceDropdown">
                <span class="dropdown-text">
                    {{ selectedOptionLabel || 'Select an option...' }}
                </span>
                <ng-icon name="heroChevronDown" [size]="'12px'" [color]="'#A89FB3'" [strokeWidth]="'2'"></ng-icon>
            </div>
            <div ngbDropdownMenu aria-labelledby="referralSourceDropdown" class="referral-dropdown-menu">
                <button *ngFor="let option of options" ngbDropdownItem (click)="selectReferralSource(option)"
                    class="dropdown-item-button">
                    {{ option.label }}
                </button>
            </div>
        </div>

        <div *ngIf="hasError" class="error-message">
            Oops - that didn't go through. Try again
        </div>

        <rosie-button [customClass]="'action narrow slimmish text-sm'" [translationKey]="'Share Feedback'"
            (click)="submitReferralSource()"></rosie-button>
    </div>

    <div class="progress-container" *ngIf="(isSubmitting || isSuccess)"
        [ngClass]="{'success': isSuccess, 'pending': isSubmitting}">
        <div>
            <div class="progress-icon">
                <ng-icon *ngIf="isSubmitting" name="heroPaperAirplane" color="#822AC6"></ng-icon>
                <ng-icon *ngIf="isSuccess" name="heroCheckBadge" color="#047857"></ng-icon>
            </div>
            <div class="progress-text">{{ isSubmitting ? 'Sending feedback...' : 'Feedback received, thank you!' }}
            </div>
        </div>
    </div>
</ng-container>